<div
        id="catalog-type-container"
        style="min-height: 100vh; position: relative"
>
  <navaar-header
          [title]="title"
          [color]="'#000000'"
  ></navaar-header>
  <section
    #containerHref
    class="wrapper-desc"
    [class.hidden]="!description"
    [innerHtml]="description | safeHtml"
  ></section>
  <section
          Pagination
          (goTo)="goToPage($event)"
          [isEnd]="isEnd"
          [disable-when-fetch-data]="isLoading"
          [class.ios-header]="device.isIOS()"
  >
    <ng-template
            ngFor
            [ngForOf]="items"
            let-item
            let-i="index"
    >
      <navaar-banner
              *ngIf="item.sliderInfo"
              [items]="item.sliderInfo.slides"
              [type-banner]="'banner-slider'"
              [type-slider]="item.sliderInfo?.sliderType"
              [event-tracker-name]="'x_plp_banner'"
              [index-banner]="i"
      >
      </navaar-banner>
      <navaar-banner
              *ngIf="item.bannerInfo"
              [items]="item.bannerInfo"
              [type-banner]="'banner'"
              [event-tracker-name]="'x_plp_banner'"
              [index-banner]="i"
      ></navaar-banner>
      <navaar-carousel
              *ngIf="item.listInfo"
              [title]="item.listInfo.title"
              [typeOfCarousel]="item.listInfo.listMode"
              [items]="item.listInfo"
              [style-show-all]="'yellow'"
              [show-rate]="true"
              [identifier]="1"
              [type-url]="item.listInfo.apiUrl"
              [badge-type]="item.listInfo.badgeId"
              [rate-style]="{background: 'rgb(255, 181, 0)'}"
              [index-carousel]="i"
              [name-tracker-event]="'x_plp_list_item'"
      ></navaar-carousel>
    </ng-template>
  </section>
</div>
